// extracted by mini-css-extract-plugin
export default {"-large":"TPIGVtBC9bL0DV5kCNZw","container":"GOZoVXlAJ6M9y5Pxgkd0","divider":"sXrFoOGn5yD1TNwd_GQH"};